<!-- prettier-ignore -->

<div class="step-traveler-type-container">
    <h1>{{'¿Cómo viajas?' | translate}}</h1>

    <div class="how-travel">
        <form [formGroup]="travelerTypeForm">
            @for(item of travellerTypes; track $index) {
                <div class="traveler-wrapper">
                    <label class="radio-image">

                        <input type="radio" name="traveler-type"
                            [value]="item.id" 
                            (focusin)="focusin($event)" 
                            [formControlName]="'traveler-type'" 
                            (change)="setSelectedOption(item.id)"
                        >

                        <div class="img-container">
                            <div class="img-wrapper" [ngClass]="{
                                'selectedRegister': travelerTypeForm.value['traveler-type'] === item.id,
                                'setOpacity': travelerTypeForm.value['traveler-type'] !== item.id
                            }">
                                <cicerone-lazy-image 
                                    [url]="item.image" 
                                    [urlFallback]="item.imageFallback" 
                                    [altImage]="item?.name?.[translate.currentLang]" 
                                />
                            </div>
                        </div>

                        <span class="traveler-title">{{ item.name?.[translate.currentLang] }}</span>

                    </label>
                </div>
            }
        </form>
    </div>

</div>
